module.exports = __webpack_public_path__ + "media/dashboard/assets/images/audio-4b6066486a3f6ea2e218e0821ff8236d.png";